<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
             <div>
              <span id="agencies-grouping-filter-organismo-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.organismo')}}</span>
              <el-form-item prop="organismo">
                <el-input
                  class="w-full"
                  v-model="form.organismo.value"
                  maxlength="500"
                  aria-labelledby="agencies-grouping-filter-organismo-label"
                  >
                  <template v-if="form.organismo.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de organismo"
                      @clear="form.organismo.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreAgrupacion.value"
                prop="nombreAgrupacion"
                :options="listGroupingForAccessibleSelect"
                :withFormItem="true"
                id-prefix="agenciesbygroupingfilter"
              >
                <template slot="label">{{$t('app.single_grouping')}}</template>
              </AccessibleElSelect>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
// import { mapGetters } from 'vuex'
import { getAgrupacionesNombreAgencies } from '@/services/configurations/grouping/getAgrupacionesNombreAgencies'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'groupingagencies',
      isOpen: this.panelOpen,
      form: {
        organismo: { label: i18n.t('app.organismo'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
      },
      listGrouping: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    listGroupingForAccessibleSelect: function () {
      return this.listGrouping.map(item => ({
        id: item,
        name: item
      }))
    }
  },
  mounted: async function () {
    const dataAgrupaciones = await getAgrupacionesNombreAgencies()
    if (dataAgrupaciones.blnError === true) {
      this.doFeedback(dataAgrupaciones.msgError + ' [Código de error: ' + dataAgrupaciones.codError + ']')
    }
    this.listGrouping = dataAgrupaciones.Respuesta
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.organismo.value = _temp.organismo !== undefined && _temp.organismo.value !== '' ? _temp.nombreAgrupacion.value : ''
        this.form.nombreAgrupacion.value = _temp.nombreAgrupacion !== undefined && _temp.nombreAgrupacion.value !== '' ? _temp.nombreAgrupacion.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        organismo: { label: i18n.t('app.organismo'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
